'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Selectors = function () {
  function Selectors(params) {
    _classCallCheck(this, Selectors);

    var success = params.success != null ? params.success : params;
    var failure = params.error != null ? params.error : {};

    this.numSuccessSelectors = 0;

    // Handle obj or array (since that is what _.size used to do)
    if (typeof (success != null ? success.length : undefined) === 'number') {
      this.numSuccessSelectors = success.length;
    } else if (success != null) {
      this.numSuccessSelectors = Object.keys(success).length;
    }

    this.successesRemaining = this.numSuccessSelectors;

    var toFind = {};
    Object.keys(success || {}).forEach(function (key) {
      var value = success[key];
      if (toFind[key] == null) {
        toFind[key] = {
          key: key,
          name: key,
          found: false,
          numChecks: 0
        };
      }
      toFind[key].successSelector = value;
    });

    Object.keys(failure || {}).forEach(function (key) {
      var value = failure[key];
      if (toFind[key] == null) {
        toFind[key] = {
          key: key,
          name: key,
          found: false,
          numChecks: 0
        };
      }
      toFind[key].failureSelector = value;
    });

    this.toFind = toFind;
  }

  _createClass(Selectors, [{
    key: 'isFinished',
    value: function isFinished() {
      return this.numSuccessSelectors > 0 && this.successesRemaining === 0 || this.getToCheck().length === 0;
    }
  }, {
    key: 'found',
    value: function found(key, success) {
      if (success == null) {
        success = true;
      }

      if (this.toFind[key]) {
        this.toFind[key].found = true;
        if (success) {
          this.toFind[key].succeeded = true;
          this.successesRemaining--;
        } else {
          this.toFind[key].failed = true;
        }
      }
    }
  }, {
    key: 'checked',
    value: function checked(key) {
      if (this.toFind[key]) {
        this.toFind[key].numChecks++;
      }
    }
  }, {
    key: '_get',
    value: function _get() {
      var _this = this;

      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'found';
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      return Object.keys(this.toFind).map(function (key) {
        return _this.toFind[key];
      }).filter(function (val) {
        return val && val[type] === value;
      });
    }
  }, {
    key: 'getToCheck',
    value: function getToCheck() {
      return this._get('found', false);
    }
  }, {
    key: 'getFound',
    value: function getFound() {
      return this._get('found');
    }
  }, {
    key: 'getSucceeded',
    value: function getSucceeded() {
      return this._get('succeeded');
    }
  }, {
    key: 'getFailed',
    value: function getFailed() {
      return this._get('failed');
    }
  }]);

  return Selectors;
}();

exports.default = Selectors;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/Reagan/static-7.24/js/selectors.js
// module id = 263
// module chunks = 0